var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DirectionSelectDialog'),_c('NotifyDialog'),_c('SignInDialog'),_c('PlayViewDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }